(() => {
  const STORAGE_KEY = 'ci_recently_viewed';
  const MAX_ITEMS = 12;

  const readHandles = () => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  };

  const writeHandles = (handles) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, MAX_ITEMS)));
  };

  const trackCurrentProduct = () => {
    const section = document.querySelector('[data-ci-recently-viewed]');
    if (!section) return;
    const productId = section.getAttribute('data-product-id');
    if (!productId) return;

    const ids = readHandles().filter((item) => String(item) !== String(productId));
    ids.unshift(String(productId));
    writeHandles(ids);
  };

  const initSplide = (sliderElement) => {
    if (!sliderElement) return;
    const slideCount = sliderElement.querySelectorAll('.splide__slide').length;
    if (!slideCount) return;

    const mount = () => {
      if (!window.Splide) {
        setTimeout(mount, 50);
        return;
      }

      const splide = new Splide(sliderElement, {
        type: 'slide',
        perPage: 6,
        perMove: 1,
        gap: 20,
        arrows: false,
        pagination: false,
        drag: slideCount > 1,
        trimSpace: true,
        keyboard: 'focused',
        breakpoints: {
          // Live ProductList--carousel tablet: cell ~48%
          1007: {
            perPage: 1,
            gap: 0,
            padding: { left: '26%', right: '26%' },
            focus: 'center',
            autoWidth: false,
          },
          // Live: left ~83px (19%), cell ~50%/220px, right peek lebih lebar
          // focus:0 = jangan center (supaya img1 tidak terdorong ke tengah)
          640: {
            perPage: 1,
            gap: 0,
            padding: { left: '19%', right: '31%' },
            focus: 0,
            autoWidth: false,
          },
        },
      });

      splide.mount();
    };

    mount();
  };

  const loadRecentlyViewed = () => {
    const target = document.querySelector('[data-ci-recently-viewed-target]');
    if (!target) return;

    const section = target.closest('.ci-recently-viewed');
    const currentProductId = section?.getAttribute('data-product-id');

    let ids = readHandles();
    if (currentProductId) {
      ids = ids.filter((id) => String(id) !== String(currentProductId));
    }

    if (!ids.length) {
      section?.classList.add('is-empty');
      return;
    }

    const query = ids.map((id) => `id:${id}`).join(' OR ');
    const searchUrl = `/search?view=recently-viewed-products&type=product&q=${encodeURIComponent(query)}`;

    fetch(searchUrl)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const slider = doc.querySelector('[data-ci-recently-viewed-slider]');
        const slides = slider ? slider.querySelectorAll('.splide__slide') : [];
        if (slider && slides.length > 0) {
          target.innerHTML = '';
          target.appendChild(slider);
          initSplide(slider);
        } else {
          section?.classList.add('is-empty');
        }
      })
      .catch(() => {
        section?.classList.add('is-empty');
      });
  };

  document.addEventListener('DOMContentLoaded', () => {
    trackCurrentProduct();
    loadRecentlyViewed();
  });
})();
